module.exports = __webpack_public_path__ + "media/images/giftaway-logo@2x-d05e4c57ed6bb9c12d8b425aeb8c258a.webp";